<script>
export default {
    name: "CookiesModal",
    data() {
        return {
            showModal: false,
            showBanner: false,
            isClosed: false,
        };
    },
    computed: {
        isProductPage() {
            return this.$route.name === "product-slug";
        },
        isNotShow() {
            return this.$route.name.includes("catalog");
        },
    },
    mounted() {
        this.checkCookies();
    },
    watch: {
        $route() {
            if (!this.isClosed) this.checkCookies();
            else this.isClosed = false;
        },
    },
    methods: {
        checkCookies() {
            this.showBanner = !JSON.parse(localStorage.getItem("cookiesAccepted"));
        },
        closeCookiesModal() {
            this.showBanner = false;
            this.isClosed = true;
            localStorage.setItem("cookiesAccepted", "true");
        },
    },
};
</script>

<template>
    <div>
        <div class="cookie-notification" v-if="showBanner && !showModal && !isNotShow">
            <span class="cookie-notification__text text_11">
                {{ $t("cookie_modal_text1") }}
                <a
                    href="https://post-post-scriptum.com/dokumenty/soglashenie-ob-obrabotke-persnonalnyh-dannyh/"
                    target="_blank"
                    >{{ $t("cookie_modal_text2") }}</a
                >
                {{ $t("cookie_modal_text3") }}
                <a href="https://post-post-scriptum.com/dokumenty/politika-konfidencialnosti/" target="_blank">{{
                    $t("cookie_modal_text4")
                }}</a
                >.</span
            >
            <svg-icon name="close" class="like-link" width="32" height="32" @click="closeCookiesModal" />
        </div>
    </div>
</template>

<style scoped lang="less">
@bg-color: #fbfbf6;
@cancel-btn: #7b7b7b;
@text-color: #000;
@link-color: #000;
@close-icon-color: #000;
@border2-color: @border2;

* {
    box-sizing: border-box;
}

.cookie-notification {
    position: fixed;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 4px;
    width: 715px;
    max-width: calc(100% - 32px);
    background-color: #000;
    padding: 16px;
    z-index: 1001;
    color: #fff;

    .like-link {
        flex-shrink: 0;
    }
    a {
        text-decoration: underline;
    }
}

@media (max-width: 576px) {
    .cookie-notification {
        width: calc(100% - 18px);
        bottom: 9px;
    }
}
</style>
